import { LayoutDashboard, User, Map } from "lucide-react";

export const getMenuItems = (user) => {
  const items = [
    {
      label: "Dashboard",
      path: "/portal/dashboard",
      permission: null,
      icon: LayoutDashboard,
    },
    {
      label: "Users",
      path: "/portal/users",
      permission: "Onboarding Manager",
      icon: User,
    },
    {
      label: "Projects",
      path: "/portal/mappings",
      permission: null,
      icon: Map,
    },
  ];

  return items.filter(
    (item) =>
      !item.permission ||
      user?.role === "super_admin" ||
      user?.permissions?.includes(item.permission),
  );
};
